import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAsyncDebounce } from 'react-table';
import { Input } from 'reactstrap';

const ReactTableFilter = ({
  rows,
  setGlobalFilter,
  globalFilter,
  placeholder,
  dataLength,
}) => {
  const [value, setValue] = useState(globalFilter);

  useEffect(() => {
    if (value !== '') {
      setGlobalFilter(value);
    } else {
      setGlobalFilter(undefined); // Mengatur filter global kembali ke keadaan awal saat input dikosongkan
    }
  }, [value, setGlobalFilter]);

  const onChange = useAsyncDebounce((item) => {
    setValue(item);
  }, 200);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);
    onChange(inputValue);
  };

  return (
    <div className="table__search">
      <Input
        className="table__search table__search-input"
        value={value}
        onChange={handleInputChange}
        placeholder={`${placeholder}`}
      />
      {dataLength !== rows.length && <span>Found {rows.length} matches</span>}
    </div>
  );
};

const filterGreaterThan = (rows, id, filterValue) => rows.filter((row) => {
  const rowValue = row.values[id];
  return rowValue >= filterValue;
});

filterGreaterThan.autoRemove = (val) => typeof val !== 'number';

ReactTableFilter.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setGlobalFilter: PropTypes.func.isRequired,
  globalFilter: PropTypes.string,
  placeholder: PropTypes.string,
  dataLength: PropTypes.number.isRequired,
};

ReactTableFilter.defaultProps = {
  globalFilter: '',
  placeholder: 'Search...',
};

export default ReactTableFilter;
